import { AgreementContainer, AgreementPaper, AgreementContent, AgreementScrollToTop } from "../AgreementLayout";
import { KVKK_POLICY_HTML } from "./content";

const KvkkPolicy = () => {
    return (
        <AgreementContainer sx={{ py: 4 }}>
            <AgreementScrollToTop />
            <AgreementPaper elevation={0} sx={{ border: "1px solid", borderColor: "divider" }}>
                <AgreementContent dangerouslySetInnerHTML={{ __html: KVKK_POLICY_HTML }} />
            </AgreementPaper>
        </AgreementContainer>
    );
};

export default KvkkPolicy;
